
/**
*
* PLUGIN: jquery.thermia.calculator
* BY: Mattias Norell, Ninetech
* VERSION: 1.1 (based on jQuery 1.9)
* BROWSERS: Safari 4+, Chrome 7+, IE8+, Firefox 4+
* ABOUT: Calculator for Thermia.se
* HOW-TO: $(div).thermiacalculator({oilPrice: 0, electricityPrice: 0, logo: true/false});
*
**/
(function ($) {
    $.fn.thermiacalculator = function (opt) {
        var defaults = {
            logo: false,
            oilSliderMax: 20,
            oilSliderStep: 0.5,
            electricitySliderMax: 100000,
            electricitySliderStep: 500,
            oilPrice: 0,
            electricityPrice: 0,
            efficiency: .75,
            oldConsumption: 0,
            newConsumption: 0,
            energysource: 'elc',
            heatingsystem: 'radiator',
            factor: 3,
            currency: 'sek',
            allowUserToSetConsumption: false,
            allowUserToSetCost: false
        };


        var options = $.extend(defaults, opt);
        var isAnimating = false;
        var mouseDownInterval = null;

        // Helpers
        Number.prototype.formatMoney = function (currency, delimiter, newdelimiter) {
            var n = this;
            var c = isNaN(currency = Math.abs(currency)) ? 2 : currency;
            var d = delimiter == undefined ? "," : delimiter;
            var t = newdelimiter == undefined ? "." : newdelimiter;
            var s = n < 0 ? "-" : "";
            var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
            var j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        };

        var isNumber = function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };


        // Init
        if (options.logo == false) $('#calculator-logo').remove();

        //var currency = getCurrency(options.currency);
        //updateCurrency(currency);

        if (!options.allowUserToSetCost) {
            $('#electricityInput, #oilInput').attr('disabled', 'disabled');
        };

        if (options.allowUserToSetConsumption) {
            $("#current-usage-input").show();
        } else {
            $("#current-usage").show();
        };

        $("#calculator-slider").slider({
            min: 0,
            max: 100000,
            step: 500,
            change: sliderChangeHandler,
            slide: sliderChangeHandler
        });

        $("#calculator-slider").slider("value", 0);

        /* Events */

        $("#current-usage-input .manual-input").keyup(function (e) {
            e.preventDefault();
            var newvalue = $(this).val();

            if (isNumber(newvalue)) {
                var sliderMax = $("#calculator-slider").slider("option", "max");

                if (newvalue > sliderMax) {
                    newvalue = sliderMax;
                    $(this).val(newvalue);
                }

                $("#current-usage-input").attr("data-manual", "true");
                $(this).attr("data-oldvalue", newvalue);
                $("#calculator-slider").slider({ value: newvalue });
            } else {
                var oldvalue = $(this).attr("data-oldvalue");
                $(this).val(oldvalue);
            }
        });


        $("#current-usage-input").focusout(function (e) {
            $(this).removeClass('active').attr("data-manual", "false");
        }).focus(function () {
            $(this).addClass('active');
        }).mouseover(function () {
            $(this).addClass('active');
        });

        $('input[name="energysource"]').on("click", function () {
            if ($(this).is(":checked")) {
                var value = $(this).val();
                var oldValue = 0;

                options.energysource = value;

                var heading = (value == 'oil') ? $('#current-usage-heading').attr('data-oil') : $('#current-usage-heading').attr('data-electricity');

                if (value == 'oil') {
                    oldValue = $("#calculator-slider").slider("value");
                    $("#calculator-slider").slider("option", "max", options.oilSliderMax);
                    $("#calculator-slider").slider("option", "step", options.oilSliderStep);

                    if (oldValue >= options.oilSliderMax) {
                        $("#calculator-slider").slider("value", options.oilSliderMax);
                    } else {
                        $("#calculator-slider").slider("value", oldValue);
                    }

                } else {
                    oldValue = $("#calculator-slider").slider("value");
                    $("#calculator-slider").slider("option", "max", options.electricitySliderMax);
                    $("#calculator-slider").slider("option", "step", options.electricitySliderStep);
                    $("#calculator-slider").slider("value", oldValue);
                }

                $('#current-usage-heading').text(heading);

                if ($(this).attr('id') == 'direct-electricity') {
                    options.heatingsystem = "radiator";
                };

                calculate(options);
            };
        });

        $('input[name="heatingsystem"]').on("click", function () {
            if ($(this).is(":checked")) {
                var value = $(this).val();
                options.heatingsystem = value;

                calculate(options);
            };
        });

        $("#electricityInput").bind("keyup", function (event) {
            var value = $(this).val();
            if (isNumber(value) && event.which != 69) {
                $(this).attr('data-old', value);
                options.electricityPrice = value;
                calculate(options);
            } else {
                $(this).val($(this).attr('data-old'));
            };
        }).val(options.electricityPrice).attr('data-old', options.electricityPrice);

        $("#oilInput").bind("keyup", function (event) {
            var value = $(this).val();
            if (isNumber(value) && event.which != 69) {
                $(this).attr('data-old', value);
                options.oilPrice = value;
                calculate(options);
            } else {
                $(this).val($(this).attr('data-old'));
            };
        }).val(options.oilPrice).attr('data-old', options.oilPrice);

        $("#calculator .calcbtn").click(function () {
            var dir = $(this).hasClass('btn-plus');
            UpdateSlider(dir);
        });

        $("#calculator .calcbtn").mousedown(function () {
            var dir = $(this).hasClass('btn-plus');
            mouseDownInterval = setInterval(function () {
                UpdateSlider(dir);
            }, 75);
        });

        $("#calculator .calcbtn").mouseup(function () {
            clearInterval(mouseDownInterval);
        });

        function UpdateSlider(direction) {
            var slider = $("#calculator-slider");
            var value = slider.slider("option", "value");
            var step = slider.slider("option", "step");
            var max = slider.slider("option", "max");
            var newvalue = (direction) ? value + step : value - step;

            if (newvalue < 0) newvalue = 0;
            if (newvalue > max) newvalue = max;

            $("#calculator-slider").slider({ value: newvalue });
        }

        $("#calculatorTotalSum").counter();

        return false;


        // Private functions


        function sliderSlideHandler(event, ui) {
            sliderChangeHandler(event, ui);
        }

        function sliderChangeHandler(event, ui) {
            var uiValue = ui.value;
            var padding = 25;
            var valueWidth = 0;

            options.oldConsumption = uiValue;

            if (options.allowUserToSetConsumption && $("#current-usage-input").attr("data-manual") != "true") {
                $("#current-usage-input .manual-input").val(uiValue);
            } else {
                $("#current-usage").text(uiValue);
            }

            if (options.allowUserToSetConsumption) {
                valueWidth = 40;
            } else {
                valueWidth = $("#calculator-slider-value").width();
            }

            var sliderWidth = $("#calculator-slider").width();
            var sliderMax = $("#calculator-slider").slider("option", "max");
            var valueLeft = parseInt((sliderWidth * (uiValue / sliderMax)) - (valueWidth / 2));

            $("#calculator-slider-value").css("left", valueLeft + padding);

            calculate();
        }

        function getCurrency(currency) {
            var returnCurrency = {};

            switch (currency) {
                case 'sek':
                    returnCurrency.unit = "kr";
                    returnCurrency.subunit = "öre";
                    break;
                case 'nok':
                    returnCurrency.unit = "kr";
                    returnCurrency.subunit = "öre";
                    break;
                case 'euro':
                    returnCurrency.unit = "euro";
                    returnCurrency.subunit = "cent";
                    break;
                case 'gbp':
                    returnCurrency.unit = "pound";
                    returnCurrency.subunit = "pence";
                    break;
                case 'usd':
                    returnCurrency.unit = "dollar";
                    returnCurrency.subunit = "cent";
                    break;
                default:
                    returnCurrency.whole = "kr";
                    returnCurrency.subunit = "öre";
            };

            return returnCurrency;
        };

        function changeCurrency(newCurrency) {
            options.currency = newCurrency;
            updateCurrency(newCurrency);
        };

        function updateCurrency(currency) {
           // $('.calculator-currency-unit').text(currency.unit);
           // $('.calculator-currency-subunit').text(currency.subunit);
        };

        function calculate() {
            var oldCost = 0;
            var newCost = 0;

            options.factor = (options.heatingsystem == "radiator") ? 3 : 3.5;

            if (options.energysource == "oil") {
                var squareMeterCompensation = 1000;
                var oldConsumptionAfterCompensation = options.oldConsumption * squareMeterCompensation;

                //oldCost = Math.round(oldConsumptionAfterCompensation * (options.oilPrice / 1000));
                oldCost = Math.round(options.oldConsumption * options.oilPrice);
                options.newConsumption = Math.round(oldConsumptionAfterCompensation / options.factor);
                newCost = Math.round((options.newConsumption * (options.electricityPrice / 10)) * options.efficiency);
            }
            else {
                oldCost = Math.round((options.oldConsumption) * (options.electricityPrice / 100));
                options.newConsumption = Math.round((options.oldConsumption) / options.factor);
                newCost = Math.round((options.newConsumption * (options.electricityPrice / 100)));
            };

            if (oldCost < 0) { oldCost = 0 };
            if (newCost < 0) { newCost = 0 };

            $("#calculator-currentcost").text(oldCost.formatMoney(0, '.', ' '));
            $("#calculator-newcost").text(newCost.formatMoney(0, '.', ' '));

            if (options.currentValue != (oldCost - newCost)) {
                var total = (oldCost > newCost) ? oldCost - newCost : 0;

                $("#calculatorTotalSum").counter({
                    Value: total,
                    Speed: 500,
                    StartAt: options.currentValue,
                    ClearBeforeRender: false,
                    onAnimationStart: function () {
                        isAnimating = true;
                    },
                    onAnimationEnd: function () {
                        isAnimating = false;
                    }
                });

                options.currentValue = total;
            }
        }
    };

})(jQuery);